














import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import type { User } from '@getaccept/lib-shared/src/users/types/user';
import type { ComputedRef, PropType } from '@vue/composition-api';
import { computed, toRefs, defineComponent } from '@vue/composition-api';
import { IconSize } from '@getaccept/lib-ui';
import { ChatHelper } from '../helpers';
import type { Message } from '../types';

export default defineComponent({
  props: {
    message: {
      type: Object as PropType<Message>,
      default: undefined,
    },
    user: {
      type: Object as PropType<User>,
      default: undefined,
    },
    recipients: {
      type: Array as PropType<Array<Recipient>>,
      default: () => [],
    },
    isOther: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { root }) {
    const { message, recipients, user, isOther } = toRefs(props);
    const replyHeader: ComputedRef<string> = computed(() => {
      const { recipientId } = message?.value?.owner || {};
      const recipient: Recipient =
        recipientId && recipients.value.find(({ id }: Recipient) => id === recipientId);

      const name: string = recipient?.fullName || user.value.fullName;
      const prefix: string = isOther.value ? '' : `${root.$t('you')} `;
      return `${prefix}${root.$t('replied-to')} ${name}`;
    });

    const text: ComputedRef<string> = computed(() =>
      message.value.deletedAt
        ? `${root.$t('deleted')} ${ChatHelper.fullTimestamp(message.value.deletedAt)}`
        : message.value.text
    );
    return {
      replyHeader,
      text,
      IconSize,
    };
  },
});
